import { gql, type TypedDocumentNode } from "@apollo/client";
import type { CommissionCampaignNode, CommissionCampaignStatus, CommissionPayoutCadence } from "./types";

export interface CreateCommissionCampaignInput {
  partnerId: string;
  programId: string;
  status: CommissionCampaignStatus;
  payoutCadence: CommissionPayoutCadence;
  startsAt: string;
  endsAt: string;
}

export interface CreateCommissionCampaignResponse {
  commissionCreateCampaign: {
    campaign: CommissionCampaignNode;
  };
}

export const CREATE_COMMISSION_CAMPAIGN_MUTATION: TypedDocumentNode<
  CreateCommissionCampaignResponse,
  { input: CreateCommissionCampaignInput }
> = gql`
  mutation CreateCommissionCampaign($input: CreateCommissionCampaignInput!) {
    commissionCreateCampaign(input: $input) {
      campaign {
        id
        editionYear
        status
        payoutCadence
        eligibilityRules {
          id
        }
        startsAt
        endsAt
        partner {
          id
          name
        }
        program {
          id
          name
          slug
        }
      }
    }
  }
`;
